import { createSignal } from "solid-js"
import type { DepthTexture } from "three"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useDepthTextureSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<DepthTexture | undefined | null>(undefined)

  return signal
})


